// J-Stream（Equipmedia）プレイヤーの埋め込み
// 各ページは .js-jstream(data-m="<動画ID>") のみ置き、共通設定はここで一括付与する。
//
// 注意: J-Stream の PlayerFactoryIF.create() は「挿入先要素が見つからないと
// document.write で書き出す」実装。ページ読み込み後（このJSの実行時）に document.write を
// 呼ぶと HTML 全体が上書きされてしまう。そこで create() 実行中だけ document.write を
// 「対象要素への追記」に差し替えて捕捉する（create の write は同期実行なので確実に拾える）。

const IFJS = 'https://ssl-cache.stream.ne.jp/www50/eqk877uebf/jmc_pub/jmc_swf/player/t3/if.js';

const COMMON = {
  b: 'eqk877uebf.eq.webcdn.stream.ne.jp/www50/eqk877uebf/jmc_pub/jmc_swf/player/',
  c: 'MTA4MzY=',
  s: {
    bskb: '10',
    fskb: '10',
    hp: 360,
    il: 'off',
    ip: 'off',
    is: 'on',
    pr: '0.5,0.7,1.2,1.5,2.0',
    rp: 'fit',
    sn: '',
    tg: 'off',
    wp: 640,
  },
};

// if.js 読み込み失敗時のフォールバック文言
const FALLBACK_HTML = '<p class="txt -center">動画を読み込めませんでした。<br>時間をおいて再度お試しください。</p>';

// --- BtoD（MAツール）動画計測 -----------------------------------------------
// userKey = セッションID(32byte) + "_" + タイムスタンプ(16byte) + "_" + ページパス(上限78byte)
// 全体で128byte上限（仕様: 指示/btd.pdf「5. 動画の埋め込み」）。
// userKey が生成できなくても動画再生は必ず行う（フェイルセーフ）。
const BTD = {
  cookieName: 'MOBYLOGTracking_Params_t_501218',
  storageKey: 'btd_fallback_session_id',
  pollInterval: 100, // クッキー取得リトライ間隔（0.1秒）
  pollMax: 50, // リトライ上限（50回）
  productionHost: 'insmednavi.jp',
  pathMax: 78, // ページパスの上限byte
  pathTrimThreshold: 70, // これを超えたら最下層ディレクトリのみ抽出（仕様指定値）
  keyMax: 128,
};

// BtoD発行クッキーの取得（無ければ空文字）
const getBtdCookie = () => {
  const pair = document.cookie
    .split(';')
    .map((s) => s.trim())
    .find((s) => s.startsWith(`${BTD.cookieName}=`));
  return pair ? decodeURIComponent(pair.slice(BTD.cookieName.length + 1)) : '';
};

// クッキー値からセッションIDを取り出す。
// 値は「ktr_sid:<32byte英数字>」形式のため、ktr_sid: の後続のみを使う
// （ベンダー指示・サンプル test_movie_jst_773_260524f.html 準拠。PDF仕様書には未記載だった部分）。
// ktr_sid: が無い場合は空文字を返し「未取得」扱い（リトライ→32byteランダムへフォールバック）
const getBtdSessionFromCookie = () => {
  const raw = getBtdCookie();
  const idx = raw.indexOf('ktr_sid:');
  if (idx === -1) return '';
  // 同クッキー内に他キーが「;」等で連結されているケースに備えて区切る（サンプル準拠）
  return raw.slice(idx + 'ktr_sid:'.length).split(/[;,&\s]/)[0];
};

// 32byteの英数字ランダム値（Math.random は予測可能なため使わない）
const generateRandomId = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return Array.from(array, (n) => chars[n % chars.length]).join('');
};

// フォールバック用セッションID。同一セッションで同じ値を引き回すため sessionStorage に保持
const getFallbackSessionId = () => {
  try {
    let id = sessionStorage.getItem(BTD.storageKey);
    if (!id) {
      id = generateRandomId();
      sessionStorage.setItem(BTD.storageKey, id);
    }
    return id;
  } catch (e) {
    // sessionStorage 不可の環境ではその場で生成（引き回しは断念）
    return generateRandomId();
  }
};

// セッションID: BtoDクッキーを 0.1秒間隔×50回まで待ち、取得できなければフォールバック。
// BtoD共通タグが無いページ（静的ビルド等）ではクッキーは発行されないため待たない
const getBtdSessionId = () =>
  new Promise((resolve) => {
    const hasBtdTag = !!document.querySelector('script[src*="mobylog.jp"]');
    let attempts = 0;
    const poll = () => {
      const value = getBtdSessionFromCookie();
      if (value) return resolve(value);
      if (!hasBtdTag || attempts >= BTD.pollMax) return resolve(getFallbackSessionId());
      attempts += 1;
      return setTimeout(poll, BTD.pollInterval);
    };
    poll();
  });

// タイムスタンプ YYYYMMDDHHmmssSS（16byte・ミリ秒2桁まで）
const getBtdTimestamp = () => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}${pad(Math.floor(d.getMilliseconds() / 10))}`;
};

// ページパス: ドメイン・パラメータを含めない。本番以外は先頭に (dev)。
// 70byteを超える場合はディレクトリで区切った最下層部分だけを抽出する（上限78byte）
const getBtdPagePath = () => {
  const prefix = window.location.hostname === BTD.productionHost ? '' : '(dev)';
  const path = prefix + window.location.pathname;
  if (path.length <= BTD.pathTrimThreshold) return path;
  const segments = window.location.pathname.split('/').filter(Boolean);
  return `${prefix}/${segments.pop() ?? ''}`.slice(0, BTD.pathMax);
};

// userKey の生成。失敗しても reject せず空文字を返す（＝計測なしで再生のみ）
const getBtdUserKey = async () => {
  try {
    const sessionId = await getBtdSessionId();
    return `${sessionId}_${getBtdTimestamp()}_${getBtdPagePath()}`.slice(0, BTD.keyMax);
  } catch (e) {
    return '';
  }
};
// --------------------------------------------------------------------------

// if.js を一度だけ読み込む（if.js 自体の読込は document.write を行わない）
const loadIfJs = () =>
  new Promise((resolve, reject) => {
    if (window.jstream_t3 && window.jstream_t3.PlayerFactoryIF) return resolve();
    const existing = document.querySelector(`script[src="${IFJS}"]`);
    if (existing) {
      existing.addEventListener('load', () => resolve());
      existing.addEventListener('error', reject);
      return;
    }
    const script = document.createElement('script');
    script.src = IFJS;
    script.charset = 'UTF-8';
    script.onload = () => resolve();
    script.onerror = reject;
    document.head.appendChild(script);
  });

// create() 実行中だけ document.write を対象要素への追記に差し替えて呼び出す
const createInto = (el, config) => {
  const origWrite = document.write;
  const origWriteln = document.writeln;
  const redirect = function (...args) {
    el.insertAdjacentHTML('beforeend', args.join(''));
  };
  document.write = redirect;
  document.writeln = redirect;
  try {
    window.jstream_t3.PlayerFactoryIF.create(config);
  } finally {
    document.write = origWrite;
    document.writeln = origWriteln;
  }
};

export const initJstreamPlayer = async () => {
  const players = document.querySelectorAll('.js-jstream[data-m]');
  if (!players.length) return;

  try {
    await loadIfJs();
  } catch (e) {
    console.error('J-Stream if.js の読み込みに失敗しました', e);
    players.forEach((el) => { el.innerHTML = FALLBACK_HTML; });
    return;
  }

  // BtoD計測用 userKey（動画を埋め込む処理の実行時点で生成。空文字なら計測なしで再生のみ）
  const userKey = await getBtdUserKey();

  players.forEach((el, index) => {
    // 挿入先ID（英字始まり・英数字のみ）。target が効く場合は appendChild、
    // 効かない場合は上記 document.write 差し替えで捕捉する。
    if (!el.id) el.id = `jstreamPlayer${index + 1}`;
    // BtoDが動画IDを計測できるようグローバルへ設定（m は動画IDの base64。指示/btd.pdf サンプル準拠）
    try {
      window.jst_movie_id = window.atob(el.dataset.m);
    } catch (e) {
      window.jst_movie_id = el.dataset.m;
    }
    createInto(el, {
      b: COMMON.b,
      c: COMMON.c,
      m: el.dataset.m,
      s: COMMON.s,
      target: el.id,
      // ユーザー別視聴解析用タグ（userKey が生成できた場合のみ付与）
      ...(userKey ? { o: { userKey } } : {}),
    });
  });
};
